import type { ApprovalRequest } from '@/lib/types';
import type { APPayload, APSummary } from './types';

function asRecord(value: unknown): Record<string, unknown> {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : {};
}

function readString(value: unknown): string | null {
  if (value === null || value === undefined) return null;
  const trimmed = String(value).trim();
  return trimmed ? trimmed : null;
}

function hasDuplicatePointer(value: unknown): boolean {
  return readString(value) !== null;
}

export function isDuplicateHistory(
  reqOrPayload: ApprovalRequest | APPayload,
  maybeSummary?: APSummary,
): boolean {
  const isRequest = 'payload' in reqOrPayload && 'status' in reqOrPayload;
  if (isRequest && (reqOrPayload as ApprovalRequest).bucket === 'DUPLICATE') {
    return true;
  }
  const status = isRequest ? (reqOrPayload as ApprovalRequest).status : 'posted';
  if (status !== 'posted') return false;

  const payload = (isRequest
    ? ((reqOrPayload as ApprovalRequest).payload ?? {})
    : reqOrPayload) as Record<string, unknown>;
  const summary = (isRequest
    ? ((reqOrPayload as ApprovalRequest).summary ?? {})
    : (maybeSummary ?? {})) as Record<string, unknown>;
  const extra = asRecord(payload.extra);
  const oracleResult = {
    ...asRecord(extra.result),
    ...asRecord(payload.oracle_result),
  };

  const candidates = [
    summary.status_label,
    summary.outcome,
    payload.status_label,
    payload.status_label_override,
    payload.error_type,
    payload.oracle_classification,
    payload.retool_status,
    oracleResult.status,
    oracleResult.intervention_type,
    oracleResult.duplicate_reason,
    oracleResult.duplicate_ref_no,
  ];
  const hasTextMarker = candidates.some((value) => {
    const s = readString(value)?.toUpperCase() ?? '';
    return s.includes('DUPLICATE') || s.includes('ALREADY_INVOICED');
  });
  return (
    hasTextMarker ||
    hasDuplicatePointer(oracleResult.duplicate_reason) ||
    hasDuplicatePointer(oracleResult.duplicate_ref_no) ||
    hasDuplicatePointer(oracleResult.duplicate_of_purch_invoice_id)
  );
}
